module.exports = __webpack_public_path__ + "img/redchirp-logo-transparent.4b439727.png";